import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Tooltip from "src/components/Tooltip"

const ReversePaymentButton = ({ disabledMessage, onClick }) => {
  const button = (
    <Button
      variant="quarternary"
      icon="fa-arrow-u-turn-up-left"
      iconStyle="solid"
      disabled={Boolean(disabledMessage)}
      onClick={onClick}
    >
      Reverse payment
    </Button>
  )

  return disabledMessage ? (
    <Tooltip
      text={disabledMessage}
      placement="top"
      variant="dark"
      maxWidth="300px"
    >
      {button}
    </Tooltip>
  ) : (
    button
  )
}

ReversePaymentButton.propTypes = {
  disabledMessage: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default ReversePaymentButton
